var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Typography from '../../Styles/Typography/Typography';
const BadgeContainer = styled.div `
  display: inline-flex;
  position: relative;
  flex-shrink: 0;
  vertical-align: middle;
`;
const BadgeStyle = styled.span `
  top: 0.4rem;
  right: 0.4rem;
  height: 20px;
  display: flex;
  padding: 0 6px;
  z-index: 1;
  position: absolute;
  flex-wrap: wrap;
  min-width: 20px;
  box-sizing: border-box;
  align-items: center;
  align-content: center;
  border-radius: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: ${(props) => props.theme.utils.getColor(props.color)};
  transform: ${(props) => props.badgeValue > 0 ? 'scale(1) translate(50%, -50%)' : 'scale(0)'};
  transform-origin: 100% 0%;
  transition: transform 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
`;
const Badge = (_a) => {
    var { secondary = false, color = 'main', children, badgeValue = 0 } = _a, props = __rest(_a, ["secondary", "color", "children", "badgeValue"]);
    return (_jsxs(BadgeContainer, Object.assign({}, props, { children: [children, _jsx(BadgeStyle, Object.assign({ badgeValue: badgeValue, secondary: secondary, color: secondary ? 'secondary' : color }, { children: _jsx(Typography, Object.assign({ size: "note", color: "#fff" }, { children: badgeValue !== 0 ? badgeValue : null })) }))] })));
};
export default Badge;
